export default "__VITE_ASSET__B1_G_DuW__"